import { Route } from "react-router-dom"
import { AppRoutes } from "@constants/AppRoutes.ts"

import MyBookings from "@pages/MyBookings/MyBookings.tsx"
import UserSettings from "@pages/UserSettings/UserSettings.tsx"
import ProtectedRoute from "@components/others/PrivateRoute/PrivateRoute.tsx"
import PersonalDataForm from "@components/dataEntry/PersonalDataForm/PersonalDataForm.tsx"
import userProfileRoutes from "@routes/UserProfileRoutes.tsx"

const UserRoutes = () => {
	return (
		<Route path={AppRoutes.user}>
			{userProfileRoutes()}

			<Route
				path={AppRoutes.userSettings}
				element={
					<ProtectedRoute>
						<UserSettings />
					</ProtectedRoute>
				}
			/>

			<Route
				path={AppRoutes.userPersonalDataForm}
				element={
					<ProtectedRoute>
						<PersonalDataForm />
					</ProtectedRoute>
				}
			/>

			<Route
				path={AppRoutes.userMyBookings}
				element={
					<ProtectedRoute>
						<MyBookings />
					</ProtectedRoute>
				}
			/>
		</Route>
	)
}

export default UserRoutes
